@if (content) {
<!-- breadcrumbs / X, L -->
<breadcrumbs class="wrap block m-t-7"
             *ifSize="'XL'"></breadcrumbs>
<!-- product galery MS -->
<product-gallery [product]="product"
                 *ifSize="'MS'"></product-gallery>
<!-- product header -->
<div class="wrap-x wrap-l m-t-7 m-t-1-s m-t-1-m m-b-16-l m-b-16-x"
     sizeClass="XL:flex">
    <!-- product galery XL -->
    <div class="c-8 m-b-0 flex-column"
         *ifSize="'XL'">
        <product-gallery class="w-12"
                         [product]="product"></product-gallery>

        <icms-outlet-block [name]="'Product gallery outlet'"
                           [variant]="product.productGalleryOutletVariant"
                           [allowOnly]="['product-view-simple-carousel']"></icms-outlet-block>
    </div>

    <!-- product details-->
    <div class="c-4 c-12-s c-12-m wrap-s wrap-m m-r-0 p-l-2-x p-l-2-l p-r-2-x p-r-2-l _afterInitiated"
         [class.m-b-0]="product.isSoldOut">
        <div [stickyPanel]="client.isX || client.isL"
             [stickyPanelOffsetTop]="70">
            <div class="p-t-2">
                <!-- product name & label -->
                <product-view-title class="block"
                                    [product]="product"
                                    [parent]="parent"></product-view-title>
                <!-- SKU & barcode -->
                @if(!product.isSoldOut) {
                <ng-container *ifTradeStore>
                    @if (product.data.gs1_barcode) {
                    <p class="m-b-2">{{'Barcode' | translate}}: {{product.data.gs1_barcode}}</p>
                    }
                    @if (product.data.rrp) {
                    <p>{{'RRP' | translate}}: <price [value]="product.data.rrp"></price>
                    </p>
                    }
                </ng-container>
                }
                <!-- price row -->
                <ng-container *ifSize="'MS'">
                    <div class="flex flex-justify-between flex-top"
                         [ngClass]="product.isSoldOut ? 'm-t-5' : 'm-t-3'">
                        @if(product.isSoldOut) {
                        @if (product.data.sku) {
                        <p>
                            <span class="m-r-1">{{'Product Code' | translate}}:</span>
                            {{product.data.sku}}
                        </p>
                        }
                        }
                        @else {
                        <product-view-price *ifNotTradeStore
                                            class="block"
                                            [product]="product"></product-view-price>
                        }

                        <product-reviews-summary class="block"
                                                 [source]="parent"></product-reviews-summary>
                    </div>
                    @if(!product.isSoldOut) {
                    <div *ifTradeStore
                         class="block m-t-7 m-t-4-s m-t-4-m">
                        <product-price-trade [product]="product"
                                             [variant]="'pdp'"></product-price-trade>
                    </div>
                    }
                </ng-container>
            </div>
            <ng-container *ifSize="'XL'">
                <div class="flex flex-justify-between"
                     [ngClass]="product.isSoldOut ? 'm-t-7' : 'm-t-3'"
                     tradeClass="flex-bottom">
                    @if(product.isSoldOut) {
                    @if (product.data.sku) {
                    <p>
                        <span class="m-r-1">{{'Product Code' | translate}}:</span>
                        {{product.data.sku}}
                    </p>
                    }
                    }
                    @else {
                    <product-view-price *ifNotTradeStore
                                        [product]="product"></product-view-price>

                    <div *ifTradeStore
                         class="block m-t-7 m-t-4-s m-t-4-m">
                        <product-price-trade [product]="product"
                                             [variant]="'pdp'"></product-price-trade>
                    </div>
                    }
                    <product-reviews-summary tradeClass="p-b-1"
                                             [source]="parent"></product-reviews-summary>
                </div>
            </ng-container>
            @if(!product.isSoldOut) {
            @if (hasOneSize && product.inStockEstimationMessage) {
            <div class="p-a b-a b-col-42 bg-col-4 m-t-6 m-t-4-m m-t-4-s col-11"
                 style="width: fit-content;">
                {{'Estimated in stock' | translate}} {{product.inStockEstimationMessage}}
            </div>
            }
            <!-- klarna pricing -->
            <product-view-klarna-msg [product]="product"
                                     *ifNotTradeStore></product-view-klarna-msg>

            <div class="p-b-2 p-t-2 p-r-1">
                <paypal-pay-in-three-message [amount]="product.price"></paypal-pay-in-three-message>
            </div>

            <!-- social components -->
            <icms-outlet [components]=" content.socialComponents"
                         [allowOnly]=" ['add-this']">
            </icms-outlet>

            <!-- configurable options -->
            <ng-container *ngTemplateOutlet="configurableOptionsTpl"></ng-container>
            <ng-container *ifNotTradeStore>
                @if (layout === ELayout.bundle) {
                <!-- bundle create set -->
                <product-bundle-options-create-set class="m-t-7 m-t-5-s m-t-5-m block"
                                                   [product]="product"
                                                   [buyRequest]="request"
                                                   [bundleSelection]="bundleSelection">
                </product-bundle-options-create-set>
                }
                @if (layout !== ELayout.bundle) {
                <!-- add to basket / wishlist buttons -->
                <product-view-add-to-basket class="m-t-5 m-t-0-s m-t-0-m block"
                                            [hideRetailQty]="content.hideRetailQty"
                                            [product]="product"
                                            [buyRequest]="request"
                                            [productConfigurableSelection]="productConfigurableSelection"
                                            [gtmAddToCartVia]="gtmAddToCartVia"></product-view-add-to-basket>
                }
            </ng-container>

            <ng-container *ifTradeStore>
                @if(product.data?.isPOS) {
                <button class="button block m-t-7 w-12"
                        [status]="posProductModalStatus"
                        (click)="openPosProductModal()">{{'Enquire' | translate}}</button>
                } @else {
                <!-- add to basket / wishlist buttons -->
                <product-view-add-to-basket class="m-t-7 m-t-5-s m-t-5-m block"
                                            [product]="product"
                                            [buyRequest]="request"
                                            [productConfigurableSelection]="productConfigurableSelection"
                                            [gtmAddToCartVia]="gtmAddToCartVia"></product-view-add-to-basket>
                }
            </ng-container>
            <!-- surcharge note -->
            <product-view-surcharge-note class="m-t-7 m-t-5-s m-t-5-m block"
                                         [variant]="'product'"
                                         [product]="product"></product-view-surcharge-note>
            <!--Countdown timer banner-->
            <icms-outlet [components]=" content.rightComponents"
                         [allowOnly]=" ['delivery-coutdown']">
            </icms-outlet>
            <!-- free delivery label -->
            <product-view-delivery-note class="block m-t-7 m-t-5-s m-t-5-m"
                                        *ifStore="'uk'"></product-view-delivery-note>
            <!-- free gift banner -->
            @if(product.data.has_free_gift){
            <product-view-free-gift-bunner class="block m-t-7 m-t-5-s m-t-5-m"></product-view-free-gift-bunner>
            }
            @if (product.data.features_section?.length) {
            <features-section *ifSize="'MS'"
                              [product]="product"></features-section>
            }
            @if (layout === ELayout.bundle) {
            <product-bundle-options-selected [product]="product"
                                             [parent]="parent"
                                             [buyRequest]="request"
                                             [bundleSelection]="bundleSelection"></product-bundle-options-selected>
            }
            } @else {
            <!-- configurable options -->
            <ng-container *ngTemplateOutlet="configurableOptionsTpl"></ng-container>
            <button *ifSize="'XL'"
                    class="button block m-t-7 w-12"
                    [disabled]="true">{{'Discontinued' | translate}}</button>

            <bottom-panel *ifSize="'SM'"
                          [elementHeight]="'bottom-panel'"
                          [bottomPanelRestricted]="['footer']">
                <button class="button block w-12"
                        [disabled]="true">{{'Discontinued' | translate}}</button>
            </bottom-panel>
            }
            <ng-container *ifSize="'XL'">
                <ng-container *ngTemplateOutlet="details"></ng-container>
            </ng-container>
        </div>
    </div>
    <ng-container *ifSize="'SM'">
        @if(product.isSoldOut) {
        <icms-outlet-block [variant]="'PDP-Discontinued'"
                           [allowOnly]="[  'related-products',
                                        'product-carousel',
                                        'advanced-commerce',]"
                           [name]="'Discontinued outlet'">
        </icms-outlet-block>
        }
        <!-- mobile sticky nav -->
        <scroll-nav></scroll-nav>
        <!-- details -->
        <ng-container *ngTemplateOutlet="details"></ng-container>
    </ng-container>
</div>
<div id="product-view-layout-bottom"
     class="_afterInitiated"></div>
<!-- orders list of named sections -->
@if(!product.isSoldOut) {
@for (blockName of product.iCmsBlockOrder; track $index) {
<ng-container *ngTemplateOutlet="iCmsNamedBlock; context: { $implicit : blockName }"></ng-container>
}
<icms-outlet [components]="content.bottomComponents"
             [allowOnly]="[
                        'page-component-product-features',
                        'product-reviews',
                        'related-products',
                        'product-carousel',
                        'advanced-commerce',
                        'hero-image'
                    ]">
</icms-outlet>

<!-- breadcrumbs / S, M -->
<breadcrumbs class="wrap block m-t-7 m-t-s m-t-5-m"
             *ifSize="'SM'"></breadcrumbs>
} @else {
<icms-outlet-block *ifSize="'XL'"
                   [variant]="'PDP-Discontinued'"
                   [allowOnly]="[  'related-products',
    'product-carousel',
    'advanced-commerce',]"
                   [name]="'Discontinued outlet'">
</icms-outlet-block>
}
}


<!-- named iCms sections  -->
<ng-template #iCmsNamedBlock
             let-name>
    @switch (name) {
    <!-- video -->
    @case ('video') {
    <icms-outlet-block class="w-12"
                       [variant]="videoBlockVariant"
                       [allowOnly]="['hero-image', 'text']"
                       [name]="'Video'">
    </icms-outlet-block>
    }
    <!-- carousel -->
    @case ('carousel') {
    <product-view-cms-carousel [defaultComponents]="content.middleComponents"
                               [variant]="product.carouselVariant">
    </product-view-cms-carousel>
    }
    <!-- tech -->
    @case ('tech') {
    <icms-outlet-block class="block w-12"
                       [variant]="product.productFeaturesVariant"
                       [allowOnly]="['page-component-product-features']"
                       [name]="'Product Features'">
    </icms-outlet-block>
    }
    <!-- highlights -->
    @case ('highlights') {
    <product-highlights [source]="parent"></product-highlights>
    }
    <!-- aswornby -->
    @case ('aswornby') {
    <icms-outlet [components]="content.instagramFeedComponents"
                 [allow]="['instagram-feed-product-page']"
                 [allowOnly]="['instagram-feed-product-page']"
                 class="block"
                 name="Instagram feed">
    </icms-outlet>
    }
    @case ('technical') {
    <product-view-cms-simple-carousel [variant]="product.productTechnicalVariant"
                                      [addWrap]="true"></product-view-cms-simple-carousel>
    }
    @case ('features') {
    <product-view-cms-simple-carousel [variant]="product.productFeaturesCarouselVariant"
                                      [addWrap]="true"></product-view-cms-simple-carousel>
    }
    @case ('athlete') {
    <product-view-cms-simple-carousel [variant]="product.productAthleteVariant"
                                      [addWrap]="true"></product-view-cms-simple-carousel>
    }
    <!-- tech spec -->
    @case ('specs') {
    <specification-section [product]="product"></specification-section>
    }
    <!-- editorial -->
    @case ('editorial') {
    <icms-outlet-block class="w-12"
                       [variant]="editorialBlockVariant"
                       [allowOnly]="['editorial-component']"
                       [name]="'Editorial'">
    </icms-outlet-block>
    }
    <!-- reviews -->
    <!-- <ng-container *ngSwitchCase="'reviews'">
  <icms-outlet [allow]="['product-reviews']"
    [allowOnly]="['product-reviews']"
    name="Product reviews"
    [components]="content.reviewsComponents">
  </icms-outlet>
</ng-container> -->
    }
</ng-template>

<!-- product details  -->
<ng-template #details>

    <!-- right side product details -->
    <product-view-details class="m-t-7 m-t-5-s m-t-5-m wrap-s wrap-m"
                          [product]="product"
                          [parent]="parent"
                          [content]="content"></product-view-details>

    <!-- fashion recommendation -->
    <product-view-fashion-recommendation [product]="product">
    </product-view-fashion-recommendation>
</ng-template>

<ng-template #configurableOptionsTpl>

    <!-- configurable options -->
    @if (parent.isConfigurable) {
    <product-configurable-options class="block"
                                  id="pdpConfigurableOptions"
                                  [product]="product"
                                  [familyAttrs]="['color']"
                                  [preselectOptions]="['color']"
                                  [preselectSingles]="true"
                                  [storage]="'read'"
                                  (selectionChange)="matchExactly($event.data)"
                                  (init)="matchExactly($event.data)">
    </product-configurable-options>
    }
</ng-template>
